import { DialogActions } from '@mui/material';
import styled from '@emotion/styled';

export const StyledDialogActions = styled(DialogActions, {
  shouldForwardProp: (prop) => prop !== 'noMargin',
})<{ noMargin?: boolean }>(({ noMargin }) => ({
  marginRight: noMargin ? '0px' : '18px',
  paddingBottom: '20px',
}));